// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 957) return "static/chunks/957-7ad195402fe6e8b5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"81":"322f0bbc73120726","282":"1ebb1a8065f9a758","418":"01ce0f1b3d9c5d21","857":"ac413db4b0cdad58","925":"aaac3a9de2a9d9ff","980":"80ae23055392cd05"}[chunkId] + ".js";
};